<template>
<w-sliding-popup v-loading="isLoading" ref="slidingPopup" :title="popupType == 'ADD' ? 'IP 검색 대역 추가' : 'IP 검색 대역 수정'" :type="type" width="500px" @close="close" @open="open">
  <div slot="content">
    <el-form :model="ipSearchFormData" label-position="top" ref="ipSearchForm" :rules="rules">
      <div>
        <div class="title-h4 title-bar">
          기본 정보
        </div>
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item label="IP 타입" prop="ipaddressApplytype">
              <el-select v-model="ipSearchFormData.ipaddressApplytype" @change="clearValidate" style="width:100%">
                <el-option v-for="item in iptypeList" :key="item.basicinfoSubid" :label="item.basicinfoSubname" :value="item.basicinfoSubid"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item v-if="ipSearchFormData.ipaddressApplytype === 'IPv4'" label="IP 검색 방법" prop="scanType">
              <el-select v-model="ipSearchFormData.scanType" @change="clearValidate" style="width:100%">
                <el-option v-for="item in scanTypeList" :key="item.id" :label="item.name" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item v-if="ipSearchFormData.ipaddressApplytype === 'IPv6'" label="IP 주소" prop="ip6StartAddress">
              <el-input v-model="ipSearchFormData.ip6StartAddress" placeholder="입력해 주세요."></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-if="ipSearchFormData.ipaddressApplytype == 'IPv4' && ipSearchFormData.scanType == 'SPOT'">
          <el-form-item label="IP 주소" prop="spotStartAddress">
            <el-input v-model="ipSearchFormData.spotStartAddress" placeholder="입력해 주세요."></el-input>
          </el-form-item>
        </el-row>
        <el-row :gutter="10" v-if="ipSearchFormData.ipaddressApplytype == 'IPv4' && ipSearchFormData.scanType == 'RANGE'">
          <el-col :span="12">
            <el-form-item label="시작 IP" prop="rangeStartAddress">
              <el-input v-model="ipSearchFormData.rangeStartAddress" placeholder="입력해 주세요." @blur="checkStartIpAddr(ipSearchFormData.rangeStartAddress)"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="종료 IP" prop="rangeEndAddress">
              <el-input v-model="ipSearchFormData.rangeEndAddress" placeholder="입력해 주세요."></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10" v-if="ipSearchFormData.ipaddressApplytype == 'IPv4' && ipSearchFormData.scanType == 'SEED'">
          <el-col :span="12">
            <el-form-item label="IP" prop="seedStartAddress">
              <el-input v-model="ipSearchFormData.seedStartAddress" placeholder="입력해 주세요."></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="서브넷 마스크" prop="seedEndAddress">
              <el-select v-model="ipSearchFormData.seedEndAddress" style="width: 100%;">
                <el-option v-for="item in subnetmaskList" :label="item.basicinfoSubname" :value="item.basicinfoSubname" :key="item.basicinfoSubid"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </div>
      <div v-if="ipSearchFormData.ipaddressApplytype == 'IPv4' && ipSearchFormData.scanType != 'SPOT'" class="mr-t25">
        <el-row class="title-bar">
          <div class="title-h4 mr-r10">예외구간 설정</div>
          <el-switch v-model="ipSearchFormData.checkExceptFlag"></el-switch>
        </el-row>
        <el-row :gutter="10" v-if="ipSearchFormData.checkExceptFlag">
          <el-col :span="12">
            <el-form-item label="예외 시작 IP" prop="exceptStartAddress">
              <el-input v-model="ipSearchFormData.exceptStartAddress" placeholder="입력해 주세요."></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="예외 종료 IP" prop="exceptEndAddress">
              <el-input v-model="ipSearchFormData.exceptEndAddress" placeholder="입력해 주세요."></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </div>
      <el-row :gutter="10">
        <el-col :span="12">
          <el-form-item label="수집 서버 그룹" prop="agentManagerGroupId">
            <el-select v-model="ipSearchFormData.agentManagerGroupId" style="width:100%">
              <el-option v-for="item in agentManagerGroupList" :key="item.agentManagerGroupId" :label="item.agentManagerGroupName" :value="item.agentManagerGroupId"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="접속 방식">
            <el-checkbox v-model="ipSearchFormData.checkIcmpFlag" true-label="1" false-label="0">ICMP</el-checkbox>
            <el-checkbox v-model="ipSearchFormData.checkSnmpFlag" true-label="1" false-label="0">SNMP</el-checkbox>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
  <div slot="footer">
    <el-button size="large" type="solid" @click="clickSaveButton">저장</el-button>
    <el-button size="large" @click="clickCancelButton">취소</el-button>
  </div>
</w-sliding-popup>
</template>

<script>
import { isEqual, isNil, clone } from 'lodash';
import { validateIpv4, validateIpv6 } from '@/utils/string';
import BasicinfoSubAPI from '@/api/model/basicinfo-sub';
import msgUtil from '@/utils/message';
import DeviceRegistrationNmsAPI from '@/api/settings/common/device-registration-nms';
import NetdeviceIpManagement from '@/api/settings/netdevice/netdevice-ip-management';

const defaultData = {
  ipaddressApplytype: 'IPv4',
  scanType: 'SPOT',
  checkExceptFlag: false,
  agentManagerGroupId: null,
  checkIcmpFlag: '1',
  checkSnmpFlag: '1',
};
export default {
  name: 'WAddIpSearchPopup',
  props: {
    popupType: String,
    selectedIpSearchRow: Object,
    type: {
      type: String,
      default: 'setting',
    },
  },
  data() {
    return {
      isLoading: false,
      ipSearchFormData: clone(defaultData),
      rules: {
        ipaddressApplytype: {
          required: true,
          message: '필수 정보입니다.',
          trigger: 'blur',
        },
        scanType: {
          required: true,
          message: '필수 정보입니다.',
          trigger: 'blur',
        },
        ip6StartAddress: {
          required: true,
          validator: this.validateIpaddress,
          trigger: 'blur',
        },
        spotStartAddress: {
          required: true,
          validator: this.validateIpaddress,
          trigger: 'blur',
        },
        rangeStartAddress: {
          required: true,
          validator: this.validateIpaddress,
          trigger: 'blur',
        },
        rangeEndAddress: {
          required: true,
          validator: this.validateIpaddress,
          trigger: 'blur',
        },
        seedStartAddress: {
          required: true,
          validator: this.validateIpaddress,
          trigger: 'blur',
        },
        seedEndAddress: {
          required: true,
          message: '필수 정보입니다.',
          trigger: 'blur',
        },
        exceptStartAddress: {
          validator: this.validateIpaddress,
          trigger: 'blur',
        },
        exceptEndAddress: {
          validator: this.validateIpaddress,
          trigger: 'blur',
        },
        agentManagerGroupId: {
          required: true,
          message: '필수 정보입니다.',
          trigger: 'blur',
        },
      },
      iptypeList: [],
      agentManagerGroupList: [],
      scanTypeList: [
        {
          id: 'SPOT',
          name: '단일 IP',
        },
        {
          id: 'RANGE',
          name: '범위',
        },
        {
          id: 'SEED',
          name: '서브넷 마스크',
        },
      ],
      subnetmaskList: [],
    };
  },
  mounted() {
    // subnetmask List api
    NetdeviceIpManagement.getSubnetmaskList().then((response) => {
      this.subnetmaskList = response.data.data;
    });
  },
  methods: {
    loadData() {},
    open() {
      BasicinfoSubAPI.getList('IPTYPE').then((response) => {
        this.iptypeList = response.data.data;
      });
      DeviceRegistrationNmsAPI.getAgentMgrGrpList().then((response) => {
        this.agentManagerGroupList = response.data.data;
        if (isEqual(this.popupType, 'ADD')) {
          this.ipSearchFormData.agentManagerGroupId = this.agentManagerGroupList[0].agentManagerGroupId;
        }
      });
      if (isEqual(this.popupType, 'UPDATE')) {
        this.ipSearchFormData = this.selectedIpSearchRow;
      }
    },
    close() {
      this.$refs.ipSearchForm.resetFields();
      this.ipSearchFormData = clone(defaultData);
    },
    closePopup() {
      this.$refs.slidingPopup.visible = false;
    },
    clickSaveButton() {
      const ipadressApplytype = this.ipSearchFormData.ipaddressApplytype;
      const scanType = this.ipSearchFormData.scanType;
      const agentManagerGroupId = this.ipSearchFormData.agentManagerGroupId;
      const checkExceptFlag = this.ipSearchFormData.checkExceptFlag;
      const checkIcmpFlag = this.ipSearchFormData.checkIcmpFlag;
      const checkSnmpFlag = this.ipSearchFormData.checkSnmpFlag;
      const resultData = {
        scanType,
        agentManagerGroupId,
        checkIcmpFlag,
        checkSnmpFlag,
      };
      if (isEqual(ipadressApplytype, 'IPv4')) {
        if (isEqual(scanType, 'SPOT')) {
          resultData.startAddress = this.ipSearchFormData.spotStartAddress;
        } else {
          if (checkExceptFlag) {
            resultData.exceptStartAddress = this.ipSearchFormData.exceptStartAddress;
            resultData.exceptEndAddress = this.ipSearchFormData.exceptEndAddress;
          } else {
            resultData.exceptStartAddress = '';
            resultData.exceptEndAddress = '';
          }
          if (isEqual(scanType, 'RANGE')) {
            resultData.startAddress = this.ipSearchFormData.rangeStartAddress;
            resultData.endAddress = this.ipSearchFormData.rangeEndAddress;
          } else {
            resultData.startAddress = this.ipSearchFormData.seedStartAddress;
            if (this.ipSearchFormData.seedEndAddress) {
              // 서브넷마스크의 경우 콤보박스에서 선택한 값에서 아이디만 추출하여 종료IP로 지정
              const substringIdx = this.ipSearchFormData.seedEndAddress.indexOf(' ');
              const endAddress = this.ipSearchFormData.seedEndAddress.substring(0, substringIdx);
              resultData.endAddress = endAddress;
            }
          }
        }
      } else {
        resultData.startAddress = this.ipSearchFormData.ip6StartAddress;
        resultData.scanType = 'SPOT';
        resultData.checkIpv6Flag = '1';
      }
      const target = 'IP 검색 대역';
      const action = msgUtil.action.SAVE;
      this.$refs.ipSearchForm
        .validate()
        .then((res) => {
          if (res) {
            if (isEqual(this.popupType, 'ADD')) {
              this.isLoading = true;
              DeviceRegistrationNmsAPI.insertNmsAutodiscovery(resultData)
                .then((response) => {
                  const result = response.data;
                  if (result.success === true) {
                    this.$message(msgUtil.getResultMsgData(action, target, true));
                    this.$emit('re-load');
                    this.closePopup();
                  } else {
                    this.$message(msgUtil.getResultMsgData(action, target, false));
                  }
                })
                .catch(() => {
                  this.$message(msgUtil.getResultMsgData(action, target, false));
                }).finally(() => {
                  this.isLoading = false;
                });
            } else {
              resultData.scanId = this.ipSearchFormData.scanId;
              this.isLoading = true;
              DeviceRegistrationNmsAPI.updateNmsAutodiscovery(resultData)
                .then((response) => {
                  const result = response.data;
                  if (result.success === true) {
                    this.$message(msgUtil.getResultMsgData(action, target, true));
                    this.$emit('re-load');
                    this.closePopup();
                  } else {
                    this.$message(msgUtil.getResultMsgData(action, target, false));
                  }
                })
                .catch(() => {
                  this.$message(msgUtil.getResultMsgData(action, target, false));
                }).finally(() => {
                  this.isLoading = false;
                });
            }
          }
        })
        .catch(() => {});
    },
    clickCancelButton() {
      this.closePopup();
    },
    clearValidate() {
      this.$refs.ipSearchForm.clearValidate();
    },
    validateIpaddress(rule, value, callback) {
      if (isNil(value) || value === '') {
        if (rule.required) {
          callback(new Error('필수 정보입니다.'));
        } else {
          callback();
        }
      }
      if (this.ipSearchFormData.ipaddressApplytype === 'IPv4') {
        if (validateIpv4(value)) {
          if (isEqual(rule.field, 'spotStartAddress') && isEqual(this.ipSearchFormData.scanType, 'SPOT')) {
            if (!isNil(this.selectedIpSearchRow)) {
              if (isEqual(this.selectedIpSearchRow.startAddress, value)) {
                callback();
              } else {
                const params = {
                  scanType: 'SPOT',
                  startAddress: value,
                };
                DeviceRegistrationNmsAPI.checkSpotIpaddresssValidation(params).then((response) => {
                  if (response.data.data) {
                    callback();
                  } else {
                    callback(new Error('이미 존재하는 단일IP 주소입니다.'));
                  }
                });
              }
            } else {
              const params = {
                scanType: 'SPOT',
                startAddress: value,
              };
              DeviceRegistrationNmsAPI.checkSpotIpaddresssValidation(params).then((response) => {
                if (response.data.data) {
                  callback();
                } else {
                  callback(new Error('이미 존재하는 단일IP 주소입니다.'));
                }
              });
            }
          } else {
            callback();
          }
        } else {
          callback(new Error('올바른 IPv4 주소형식을 입력해주세요'));
        }
      } else if (this.ipSearchFormData.ipaddressApplytype !== 'IPv4') {
        if (validateIpv6(value)) {
          if (isEqual(rule.field, 'spotStartAddress') && isEqual(this.ipSearchFormData.scanType, 'SPOT')) {
            if (!isNil(this.selectedIpSearchRow)) {
              if (isEqual(this.selectedIpSearchRow.startAddress, value)) {
                callback();
              } else {
                const params = {
                  scanType: 'SPOT',
                  startAddress: value,
                };
                DeviceRegistrationNmsAPI.checkSpotIpaddresssValidation(params).then((response) => {
                  if (response.data.data) {
                    callback();
                  } else {
                    callback(new Error('이미 존재하는 단일IP 주소입니다.'));
                  }
                });
              }
            } else {
              const params = {
                scanType: 'SPOT',
                startAddress: value,
              };
              DeviceRegistrationNmsAPI.checkSpotIpaddresssValidation(params).then((response) => {
                if (response.data.data) {
                  callback();
                } else {
                  callback(new Error('이미 존재하는 단일IP 주소입니다.'));
                }
              });
            }
          } else {
            callback();
          }
        } else {
          callback(new Error('올바른 IPv6 주소형식을 입력해주세요'));
        }
      }
    },
    /**
     * IP 검색 대역 추가 팝업인 경우, 시작 IP가 종료 IP에 대입된다.
     * @author yelim
     */
    checkStartIpAddr(value) {
      if (isEqual(this.popupType, 'ADD')) {
        if (validateIpv4(value)) {
          this.$set(this.ipSearchFormData, 'rangeEndAddress', value);
        }
      }
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/settings/basic/DeviceRegistration/Network/popup/AddIpSearchPopup.vue